import React from "react";
import { Save, Loader } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

export function EditorFooter({ onClose, onSave, saving, dirty, result }) {
  return (
    <div
      className="flex items-center justify-between px-6 py-4 border-t border-[#DCD4C6] flex-shrink-0"
      style={{ background: "#F1EBE1", borderRadius: "0 0 3px 3px" }}
    >
      <button
        onClick={onClose}
        className="px-5 py-2.5 text-sm border border-[#DCD4C6] text-[#5C554E] hover:border-[#8B5E34] transition-colors"
        style={{ ...LORA, borderRadius: "2px" }}
        data-testid="editor-cancel-btn"
      >
        Annuler
      </button>
      <button
        onClick={onSave}
        disabled={saving || !dirty || !result}
        className="flex items-center gap-2 px-6 py-2.5 text-sm bg-[#C17F59] text-[#F9F6F0] hover:bg-[#A86A46] disabled:opacity-40 transition-colors"
        style={{ ...LORA, borderRadius: "2px" }}
        data-testid="editor-save-btn"
      >
        {saving ? (
          <Loader size={14} strokeWidth={1.5} className="animate-spin" />
        ) : (
          <Save size={14} strokeWidth={1.5} />
        )}
        {saving ? "Sauvegarde..." : "Sauvegarder les modifications"}
      </button>
    </div>
  );
}
